import { defaultInnerCopper, defaultOutterCopper } from './Copper';
import { Core, anonymousCore } from 'models/Core';
import { Prepreg, anonymousPrepreg } from 'models/Prepreg';

function initLayers(spec){
  const {
    numberOfCopperLayers,
    outerCopperWeight,
    innerCopperWeight,
    defaultCore,
    defaultPrepreg,
  } = spec;

  let layers = [],
    currentNumberOfCopperLayers = 2
  ;

  const innerCopper = () => defaultInnerCopper(innerCopperWeight);
  const outterCopper = () => defaultOutterCopper(outerCopperWeight);
  const core = () => defaultCore ? new Core(defaultCore) : anonymousCore();
  const prepreg = () => defaultPrepreg ? new Prepreg([defaultPrepreg]) : anonymousPrepreg();

  layers.push(outterCopper());
  layers.push(prepreg());

  while(currentNumberOfCopperLayers < numberOfCopperLayers) {

    layers.push(innerCopper());
    layers.push(core());
    layers.push(innerCopper());

    layers.push(prepreg());

    currentNumberOfCopperLayers += 2;
  }

  layers.push(outterCopper());

  return layers;
}

export default function createFoil(spec){
  return initLayers(spec);
}



// WEBPACK FOOTER //
// ./src/models/Foil.js